/* eslint-disable quotes */

// components.application.dashboard.summaries.progress

export const PROGRESS = {
  title: 'To Do',
  description: 'Percentage of tasks completed'
};
